<template>
  <v-dialog ref="dialog" v-model="visible" :max-width="breit ? 1000 : 560" scrollable>
    <v-card>
      <v-card-title class="text-h6">{{ titel }}</v-card-title>
      <v-card-text style="max-height: 65vh">
        <slot/>
        <label v-if="pflichtText" class="dp-confirm">
          <input v-model="bestaetigt" type="checkbox">
          <span>{{ pflichtText }}</span>
        </label>
      </v-card-text>
      <v-card-actions>
        <v-spacer/>
        <v-btn text @click="visible = false">{{ okText ? 'Abbrechen' : 'Schließen' }}</v-btn>
        <v-btn v-if="okText" :color="okFarbe" depressed :disabled="!!pflichtText && !bestaetigt" :loading="busy" @click="$emit('ok')">{{ okText }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import raiseStack from './raiseStack'

// Confirmation dialog; with pflichtText the user must tick a checkbox first
// (replacing existing weekly sources is always explicit).
export default {
  name: 'BestaetigenDialog',
  mixins: [raiseStack],
  props: {
    titel: {type: String, default: ''},
    okText: {type: String, default: ''},
    okFarbe: {type: String, default: 'primary'},
    pflichtText: {type: String, default: ''},
    breit: {type: Boolean, default: false},
    busy: {type: Boolean, default: false},
  },
  data: () => ({visible: false, bestaetigt: false}),
  methods: {
    open () {
      this.bestaetigt = false
      this.visible = true
    },
    close () {
      this.visible = false
    },
  },
}
</script>

<style scoped>
.dp-confirm {
  display: flex;
  gap: 9px;
  align-items: flex-start;
  margin-top: 14px;
  padding: 10px 12px;
  background: #fff8e1;
  border: 1px solid #ffe082;
  border-radius: 3px;
  font-size: 13px;
  cursor: pointer;
}
.dp-confirm input {
  margin-top: 3px;
  accent-color: #3f51b5;
}
</style>
